<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>财务信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="非常重要: 提供贵司的近三年财务报告，有利于展示您的经营与发展状况。">
			</el-alert>
		</div>
		<el-row class="mg-b5">
			<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="yaer" label="年" width="100"></el-table-column>
				<el-table-column prop="currency" label="货币种类" :show-overflow-tooltip="true" width="120">
				</el-table-column>
				<el-table-column prop="qySumZc" label="企业总资产(万)" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="sumFz" label="企业总负债(万)" :show-overflow-tooltip="true" >
				</el-table-column>
				<el-table-column prop="ldZc" label="流动资产(万)" :show-overflow-tooltip="true" >
				</el-table-column>
				<el-table-column prop="ldFz" label="流动负债(万)" :show-overflow-tooltip="true" >
				</el-table-column>
				<el-table-column prop="yySr" label="营业收入(万)" :show-overflow-tooltip="true" >
				</el-table-column>
				<el-table-column prop="netProfit" label="净利润(万)" :show-overflow-tooltip="true" >
				</el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="操作" width="100" align="center" fixed="right">
					<template slot="header" slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleAdd" >新增
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)" >修改
						</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row.rowId)" >删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="nextStep" size="small">下一步</el-button>
			</span>
		</div>
		<el-dialog :visible.sync="openDialog" width="800px" :title="title" :close-on-click-modal="false">
			<el-form label-width="130px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="12">
						<el-form-item label="年份" prop="yaer">
							<el-date-picker v-model="form.yaer" type="year" value-format="yyyy" placeholder="选择年份">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="货币种类" prop="currency">
							<el-select v-model="form.currency" placeholder="请选择" style="width: 100%;" filterable>
								<el-option v-for="item in zcCurrencys" :key="item.id" :label="item.name"
									:value="item.code">
									<span style="float: left">{{ item.name }}</span>
									<span
										style="float: right; color: #8492a6; font-size: 13px">{{ item.shCountry }}</span>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="企业总资产(万)" prop="qySumZc">
							<el-input-number v-model="form.qySumZc" controls-position="right" style="width: 100%">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="企业总负债(万)" prop="sumFz">
							<el-input-number v-model="form.sumFz" controls-position="right" style="width: 100%">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="流动资产(万)" prop="ldZc">
							<el-input-number v-model="form.ldZc" controls-position="right" style="width: 100%">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="流动负债(万)" prop="ldFz">
							<el-input-number v-model="form.ldFz" controls-position="right" style="width: 100%">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="营业收入(万)" prop="yySr">
							<el-input-number v-model="form.yySr" controls-position="right" style="width: 100%">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="净利润(万)" prop="netProfit">
							<el-input-number v-model="form.netProfit" controls-position="right" style="width: 100%">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="form.remark" type="textarea" placeholder="请输入备注" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		supplierFinanceList,
		addSupplierFinance,
		editSupplierFinance,
		delSupplierFinance,
	} from '@/api/gys/supplierFinance.js'
	import {
		basicCurrencyListAll
	} from '@/api/basic/basicCurrency.js'
	import{addSupplierApprovalMx, getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	import { createHash } from '@/utils/index'
	export default {
		name: "SupplierFinance",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				zcCurrencys: [],
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					yaer: [{
						required: true,
						message: '请输入年',
						trigger: 'blur'
					}],
					currency: [{
						required: true,
						message: '请输入货币种类',
						trigger: 'blur'
					}],
					qySumZc: [{
						required: true,
						message: '请输入企业总资产(万)',
						trigger: 'blur'
					}],
					sumFz: [{
						required: true,
						message: '请输入企业总负债(万)',
						trigger: 'blur'
					}],
					ldZc: [{
						required: true,
						message: '请输入流动资产(万)',
						trigger: 'blur'
					}],
					ldFz: [{
						required: true,
						message: '请输入流动负债(万)',
						trigger: 'blur'
					}],
					yySr: [{
						required: true,
						message: '请输入营业收入(万)',
						trigger: 'blur'
					}],
					netProfit: [{
						required: true,
						message: '请输入净利润(万)',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
			this.getList();
			this.getBasicCurrencyListAll();
		},
		methods: {
			getBasicCurrencyListAll: function() {
				let _this = this;
				basicCurrencyListAll().then(response => {
					if (response.data.code === 0) {
						_this.zcCurrencys = response.data.data;
					}
				});
			},
			async getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierFinance',
					classTypeIndex:'0',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res}) => {
					console.log(res)
					this.tableData = [];
					if(res.data && res.data.jsonData){
						this.tableData = JSON.parse(res.data.jsonData)
					}
				})
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					yaer: undefined,
					currency: "CNY",
					qySumZc: undefined,
					sumFz: undefined,
					ldZc: undefined,
					ldFz: undefined,
					yySr: undefined,
					netProfit: undefined,
					zcFzl: undefined,
					ldBl: undefined,
					sumZcSyl: undefined,
					status: 0,
					remark: undefined,
					hId: this.basicId,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						let oldData = JSON.parse(JSON.stringify(_this.tableData))
						let data = JSON.parse(JSON.stringify(_this.form));
						if (data.rowId != undefined) {
							let num = -1;
							oldData.forEach((nItem,index)=>{
								if(nItem.rowId == data.rowId){
									num = index;
								}
							})
							if(num>=0){
								oldData[num] = data;
							}
							_this.addFun(oldData);
						} else {
							data.rowId = createHash();
							oldData.push(data)
							_this.addFun(oldData);
						}
					}
				});
			},
			addFun(data){
				let _this = this;
				addSupplierApprovalMx({
					classType:'com.srm.entity.SupplierFinance',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
					jsonData:JSON.stringify(data)
				}).then((res)=>{
					_this.$success('添加成功');
					_this.openDialog = false;
					_this.getList();
				})
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},

			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 6);
			},
			//下一步
			nextStep: function() {
				if (this.tableData.length <= 0) {
					this.$notify({
						message: '至少输入一条财务信息',
						type: 'error'
					});
					return false;
				}
				this.bus.$emit('stepsFun', 8);
			},


			handleDel: function(id) {
				let _this = this;
				let oldData = JSON.parse(JSON.stringify(_this.tableData))
				let newData = [];
				oldData.forEach((item)=>{
					if(item.rowId != id){
						newData.push(item)
					}
				})
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						_this.addFun(param);
					},
					data: newData //参数对象 主要回调函数用
				});
			},


			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			},

		}
	};
</script>
<style scoped="scoped">
</style>
